<template>
  <div class="container-fluid domainsConfig weflix-admin-domain">
    <TitlePage
      title="Configurações de Domínio"
      subtitle="Gerencie os domínios do seu sistema Weflix"
      :hasMargin="false"
    />

    <div class="settings-layout" v-if="hasReady">
      <div class="settings-panel domain-settings-panel contetContainerEditVideo">
        <section class="domain-section">
          <h5 class="domain-section-title">Domínio Weflix</h5>
          <p class="domain-section-lead">
            O Weflix cria automaticamente um domínio com base no nome da sua loja.
          </p>
          <p class="domain-callout">
            <strong>Atenção:</strong> ao atualizar o domínio, você será redirecionado e precisará entrar de novo. A
            propagação pode levar até <strong>20 minutos</strong>.
          </p>
          <div class="form-group flex domain domain-fields-row domain-field-grid">
            <div class="form-group domain-field">
              <div class="form-label">
                <label>Nome do Domínio Weflix</label>
              </div>
              <div class="form-input">
                <div class="flex domain_input domain-input-with-action">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Meu Domínio"
                    v-model="domainWeflix"
                    @keyup="createFullDomain()"
                  />
                  <fa icon="fa-check icon_check" v-if="hasValidDomain === true" />
                  <fa icon="fa-times icon_check" v-if="hasValidDomain === false" />
                  <button type="button" class="btn verify" @click="verifyDomain">Verificar</button>
                </div>
                <small class="small field-hint">Apenas texto, sem espaços ou caracteres especiais. Máx. 30 caracteres.</small>
              </div>
            </div>
            <div class="domainPreview domain-field">
              <div class="form-label">
                <label>Domínio final Weflix</label>
              </div>
              <div class="form-input">
                <div class="domain-value-copy-line">
                  <input
                    type="text"
                    class="form-control disabled"
                    placeholder="https://www.seudominio.weflix.com.br"
                    v-model="fullDomainWeflix"
                    disabled
                  />
                  <button
                    type="button"
                    class="domain-copy-btn domain-copy-btn--inline"
                    aria-label="Copiar domínio"
                    @click="copyToClipboard(fullDomainWeflix)"
                  >
                    <i class="pi pi-copy"></i>
                  </button>
                </div>
                <small class="small field-hint">Endereço público da sua loja neste domínio.</small>
              </div>
            </div>
          </div>
        </section>

        <div class="domain-section-spacer" aria-hidden="true" />

        <section class="domain-section">
          <h5 class="domain-section-title">Domínio próprio</h5>
          <p class="domain-section-lead">
            Use um domínio que você já possui. Configure um registro <strong>CNAME</strong> (ou <strong>A</strong> para
            root) no painel do seu provedor de DNS.
          </p>
          <p class="domain-callout">
            <strong>Atenção:</strong> após salvar, pode ser necessário fazer login de novo. A propagação pode levar até
            <strong>24 horas</strong>.
          </p>

          <div class="form-group flex domain domain-field-grid domain-own-grid">
            <div class="col-form-inner domain-field">
              <div class="form-group">
                <div class="form-label">
                  <label>Domínio primário</label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="https://www.seudominio.com.br"
                    v-model="domainPrimary"
                  />
                  <small class="small field-hint">URL principal de acesso à loja.</small>
                </div>
              </div>
            </div>
            <div class="col-form-inner domain-field">
              <div class="form-group">
                <div class="form-label">
                  <label>Domínio adicional</label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="https://www.seudominio.com.br"
                    v-model="domainSecondary"
                  />
                  <small class="small field-hint">Opcional — segundo endereço para a mesma loja.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="dns-instructions">
            <h6 class="dns-instructions-title">Valores para apontamento</h6>
            <p class="dns-instructions-lead">Copie e cole no seu provedor de DNS.</p>
            <div class="info_pointer dns-cards">
              <div class="dns-card dns-card--split CNAME">
                <div class="dns-card-info">
                  <span class="dns-card-badge">CNAME</span>
                  <p class="dns-card-text">Aponte o subdomínio (ex.: <code>www</code>) para:</p>
                </div>
                <div class="dns-card-values">
                  <div class="form-input dns-value-row">
                    <input
                      type="text"
                      class="form-control disabled cname"
                      placeholder="app.weflix.com.br"
                      disabled
                      readonly
                    />
                    <button
                      type="button"
                      class="domain-copy-btn"
                      aria-label="Copiar CNAME"
                      @click="copyToClipboard('app.weflix.com.br')"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="dns-card dns-card--split A">
                <div class="dns-card-info">
                  <span class="dns-card-badge">Registro A</span>
                  <p class="dns-card-text">Para o domínio raiz (<code>@</code>), use um destes IPs:</p>
                </div>
                <div class="dns-card-values">
                  <div class="dns-ip-list">
                    <div class="form-input dns-value-row">
                      <input
                        type="text"
                        class="form-control disabled ip"
                        placeholder="35.174.239.148"
                        disabled
                        readonly
                      />
                      <button
                        type="button"
                        class="domain-copy-btn"
                        aria-label="Copiar IP"
                        @click="copyToClipboard('35.174.239.148')"
                      >
                        <i class="pi pi-copy"></i>
                      </button>
                    </div>
                    <div class="form-input dns-value-row">
                      <input
                        type="text"
                        class="form-control disabled ip"
                        placeholder="54.208.52.130"
                        disabled
                        readonly
                      />
                      <button
                        type="button"
                        class="domain-copy-btn"
                        aria-label="Copiar IP"
                        @click="copyToClipboard('54.208.52.130')"
                      >
                        <i class="pi pi-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="info_doubt domain-help-foot">
            <p>
              Dificuldade com os apontamentos?
              <a href="" class="domain-help-link">Siga o tutorial passo a passo</a>.
            </p>
          </div>
        </section>
      </div>

      <div class="actions configGeneralWeflix">
        <v-btn variant="flat" color="primary" size="large" min-width="160" class="settings-save-btn" @click="editDomain">
          Salvar alterações
        </v-btn>
      </div>
    </div>

    <Loader :hasReady="hasReady" />
  </div>
</template>

<script>
import apiDomain from '@/utils/Weflix/domain';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader';
import apiWebsite from '@/utils/Weflix/website';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data() {
    return {
      domainWeflix: '',
      fullDomainWeflix: '',
      domainPrimary: '',
      domainSecondary: '',
      hasReady: false,
      hasData: false,
      hasValidDomain: null,
    };
  },
  computed: {
    ...mapState(['token']),
  },
  components: {
    Loader,
    TitlePage,
  },
  methods: {
    async getDomain() {
      try {
        const response = await apiDomain.getDomain(this.token);
        this.hasReady = true;
        this.domainWeflix = response.url.replace('https://', '').split('.')[0];
        this.fullDomainWeflix = response.url;
        this.domainPrimary = response.url1;
        this.domainSecondary = response.url2;
        this.hasData = response.url != null || response.url != '' ? true : false;
      } catch (error) {
        console.error('Erro ao obter dados do dominio:', error);
      }
    },
    async editDomain() {
      this.hasReady = false;
      const payload = {
        url: this.hasData == true ? this.domainWeflix : 'https://' + this.domainWeflix + '.weflix.com.br',
        url1: this.domainPrimary,
        url2: this.domainSecondary,
      };
      try {
        await apiDomain.editDomain(this.token, payload);
        this.hasReady = true;
        this.notify('Domínio atualizado com sucesso!', 'success');
      } catch (error) {
        console.error(error);
        this.hasReady = true;
        this.notify('Erro ao atualizar domínio!', 'error');
      }
    },
    createFullDomain() {
      if (this.domainWeflix) {
        this.domainWeflix = this.domainWeflix.replace(/[^\w\s]/gi, '').replace(/\s+/g, '').toLowerCase();
        this.fullDomainWeflix = 'https://' + this.domainWeflix + '.weflix.com.br';
      } else {
        console.error('domainWeflix está undefined');
      }
    },
    async verifyDomain() {
      const payload = {
        url: this.fullDomainWeflix,
      };
      try {
        const response = await apiWebsite.verifyDomaintData(this.token, payload);
        this.hasValidDomain = response;
      } catch (error) {
        console.error('Erro ao verificar dominio:', error);
      }
    },
    copyToClipboard(text) {
      if (text == null || text === '') return;
      navigator.clipboard.writeText(String(text));
      this.notify('Copiado para a área de transferência.', 'success');
    },
    notify(message, type = 'info') {
      toast(message, {
        autoClose: 3000,
        position: 'top-right',
        theme: 'light',
        limit: 1,
        type: type,
        dangerouslyHTMLString: true,
      });
    },
  },
  created() {
    this.getDomain();
  },
};
</script>

<style scoped lang="scss">
@import url('./css/domains.css');

.container-fluid.domainsConfig.weflix-admin-domain {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0;
  padding: 20px;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
}

.titleContainer {
  margin-bottom: 28px;
}

.titleContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.titleContainer small {
  color: #666;
  font-size: 14px;
}

.settings-layout {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.domain-settings-panel.settings-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
}

.domain-section {
  text-align: left;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.domain-section-title {
  margin: 0 0 0.5rem;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.02em;
}

.domain-section-lead {
  margin: 0 0 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #4b5563;
  max-width: none;
}

.domain-section-lead:last-of-type {
  margin-bottom: 1rem;
}

.domain-callout {
  margin: 0 0 1.35rem;
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: #374151;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  max-width: none;
}

.domain-callout strong {
  color: #92400e;
}

.domain-section .form-label label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.field-hint {
  display: block;
  margin-top: 0.4rem !important;
  font-size: 0.75rem !important;
  line-height: 1.4;
  color: #6b7280 !important;
}

.domain-section-spacer {
  height: 1px;
  margin: 1.75rem 0;
  background: linear-gradient(90deg, transparent, #e5e7eb 15%, #e5e7eb 85%, transparent);
  border: none;
}

/* gap com !important: .form-group.flex.domain em domains.css vencia por especificidade (10px) */
.domain-field-grid {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 2.5rem !important;
  row-gap: 1.5rem !important;
  gap: 1.5rem 2.5rem !important;
  width: 100% !important;
  margin: 0 !important;
  padding-left: 0 !important;
  flex-wrap: unset !important;
  align-items: start !important;
}

.domain-field-grid > .domain-field,
.domain-field-grid > .form-group.domain-field,
.domain-field-grid > .domainPreview.domain-field,
.domain-field-grid > .col-form-inner.domain-field {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  flex: none !important;
}

.domain-own-grid {
  margin-bottom: 1.5rem !important;
}

.domain-input-with-action {
  position: relative;
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
  flex-wrap: nowrap;
  min-width: 0;
}

.domain-input-with-action .form-control {
  flex: 1;
  min-width: 0;
}

.domain-value-copy-line {
  display: flex;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.domain-value-copy-line .form-control {
  flex: 1;
  min-width: 0;
}

.domainPreview.domain-field .form-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.domain-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.5rem;
  min-height: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: #f3f4f6;
  color: #250891;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.domain-copy-btn--inline {
  position: static;
  transform: none;
}

.domain-copy-btn:hover {
  background: #e8e4f5;
  color: #1a0668;
}

.domain-copy-btn .pi {
  font-size: 0.95rem;
}

.dns-instructions {
  margin-top: 0.25rem;
}

.dns-instructions-title {
  margin: 0 0 0.25rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: #1f2937;
}

.dns-instructions-lead {
  margin: 0 0 1rem;
  font-size: 0.8125rem;
  color: #6b7280;
}

.dns-cards.info_pointer {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.dns-cards.info_pointer > div {
  width: 100% !important;
}

.dns-card {
  padding: 1rem 1.1rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.dns-card.dns-card--split {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  flex-wrap: wrap;
}

.dns-card-info {
  flex: 1 1 14rem;
  min-width: min(100%, 11rem);
  max-width: 100%;
}

.dns-card-info .dns-card-text {
  margin-bottom: 0;
}

.dns-card-values {
  flex: 1 1 14rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.dns-card-values .dns-ip-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.dns-card .form-input.dns-value-row {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
  width: auto !important;
  max-width: 100% !important;
  min-width: 0;
  gap: 0.75rem;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box;
}

.dns-card .dns-value-row .form-control {
  flex: 1 1 auto;
  min-width: 10rem;
  max-width: min(24rem, 70vw);
  width: auto !important;
}

.dns-card-badge {
  display: inline-block;
  margin-bottom: 0.5rem;
  padding: 0.2rem 0.55rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #250891;
  background: #ede9fe;
  border-radius: 6px;
}

.dns-card-text {
  margin: 0.35rem 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #4b5563;
}

.dns-card-text code {
  font-size: 0.8em;
  padding: 0.1rem 0.35rem;
  background: #f3f4f6;
  border-radius: 4px;
  color: #1f2937;
}

.dns-card .dns-value-row .domain-copy-btn {
  width: 2.5rem;
  min-height: 2.5rem;
  flex-shrink: 0;
}

.domain-help-foot {
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #f0f2f5;
}

.domain-help-foot p {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #6b7280;
}

.domain-help-link {
  color: #250891;
  font-weight: 600;
  text-decoration: none;
}

.domain-help-link:hover {
  text-decoration: underline;
}

.domain-fields-row {
  margin-top: 0 !important;
}

.container-fluid.domainsConfig.weflix-admin-domain .domain-settings-panel .form-group.flex.domain .col-form-inner.col-6.col-md-6.col-lg-6 {
  margin-top: 0 !important;
  cursor: default !important;
}

.actions.configGeneralWeflix {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  bottom: auto;
  right: auto;
}

.settings-save-btn {
  font-weight: 600;
  letter-spacing: 0.02em;
}

@media (max-width: 768px) {
  .container-fluid.domainsConfig.weflix-admin-domain {
    padding: 15px;
  }

  .domain-field-grid,
  .dns-cards.info_pointer {
    grid-template-columns: 1fr !important;
  }

  .dns-card.dns-card--split {
    flex-direction: column;
  }

  .dns-card-values {
    align-items: stretch !important;
    width: 100%;
    max-width: 100%;
  }

  .dns-card-values .dns-ip-list {
    align-items: stretch;
  }

  .dns-card .form-input.dns-value-row {
    width: 100% !important;
    max-width: 100% !important;
  }

  .dns-card .dns-value-row .form-control {
    max-width: none;
    min-width: 0;
  }

  .actions.configGeneralWeflix .settings-save-btn {
    width: 100%;
  }
}
</style>
